module.exports = __webpack_public_path__ + "img/logo.7b7179e6.jpg";